export default __webpack_public_path__ + "static/media/img-green-mining.65cfcf3c.png";